import { render } from "./DropdownSelectIcon.vue?vue&type=template&id=87e1b184"
const script = {}

import exportComponent from "/home/runner/work/lorem-support-frontend/lorem-support-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__